<template>
  <v-container>
    <v-btn @click="getUserTable()">Load Data</v-btn>
    <v-switch label="Filtered" v-model="untagged"></v-switch>
    <v-card class="pa-3">
      <p class="title">Group Sizes</p>
      <p v-for="(value, key) in groups" :key="key">{{key}} {{value}}</p>
    </v-card>
    <v-card class="pa-3">
      <p class="title">Individual Users</p>
      <v-card outlined v-for="(user, key) in filteredUsers" :key="key">
        <v-layout class="ma-3" row >
            <v-flex xs3>{{user.firstname}} {{user.lastname}}</v-flex>
            <v-flex xs3 >{{user.email}}</v-flex>
            <v-flex xs1 v-if="user.created" ><v-card color="blue">{{showDate(user.created)}}</v-card></v-flex>
            <v-flex xs3 >
              <v-select @change="saveUser(user)" multiple :items="list" v-model="user.cohorts"></v-select>
            </v-flex>
        </v-layout>
      </v-card>
    </v-card>


  </v-container>


</template>
<script>
import firebase from 'firebase'
import _ from 'underscore'
import moment from 'moment'
export default {
  name: 'CohortManagement',
  data() {
    return {
      users: null,
      list: ['ucd2023', 'ucd2024', 'ucd2025', 'ucd2026', 'ucdIMresident', 'other', 'ucdAdmin', 'nonDavis', 'unknown', 'testAccount', 'ucdOther', 'mistake'],
      untagged: false,
      groups: null

    }
  },
  computed: {
    filteredUsers() {
      if (this.users != null && !this.untagged) {
        return this.users
      }
      else if (this.untagged) {
        return this.users.filter(user => {return user.cohorts.length == 0})
      }
      else {
        return null
      }
    }
  },
  methods: {
    getUserTable() {
      this.users = []
      firebase.firestore().collection('users').get().then(snapshot => {
        snapshot.forEach(doc => {
          let result = doc.data()
          result.id = doc.id
          this.users.push(result)
        })
        this.users = _.sortBy(this.users, 'cohorts').reverse()
        let groups = _.countBy(this.users, user => {
          if (user.hasOwnProperty('cohorts') && user.cohorts.length > 0) {
            return user.cohorts[0]
          }
          else {
            return 'newUser'
          }
        })
        this.groups = groups
      })

    },


    saveUser(user) {
      firebase.firestore().collection('users').doc(user.id).update({
        cohorts: user.cohorts
      })
    },
    showDate(firebaseTimestamp) {
      return moment(firebaseTimestamp.toDate()).format('YYYY-MM-DD')
    }
  }
}
</script>
